import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class HoursTypeColumn extends Column {
    title = 'table.employeeHour.hoursType';
    property = 'hoursDisplayName';
    sortField = 'hoursType';
    sortable = true;
    type: CellDisplay = CellDisplay.string;
}
